<template>
    <div v-if="isAllowed()" class="delivery-calculator-box mt-5">
        <h3>{{$t('pds.delivery_cost.title')}}</h3>
        <div class="form-group">
            <label>{{ $t('pds.delivery_cost.enter_address') }}</label>
            <vue-google-autocomplete
                id="map"
                ref="toAddress"
                classname="form-control"
                :placeholder="$t('cdb.subscriptions.address')"
                v-on:placechanged="getAddressData"
                :country="this.$root.whitelabel.setting('wlCountry')"
                types="geocode"
                @blur="onBlur(address)"
            >
            </vue-google-autocomplete>
            <small class="text-danger" v-if="error">{{ error }}</small>
        </div>
        <button type="button" class="btn btn-secondary btn-block" @click="getCosts" v-if="!isLoading && !isSubmitting">{{$t('pds.delivery_cost.calculate')}}</button>
        <button type="button" class="btn btn-secondary btn-block" v-if="isLoading || isSubmitting">{{$t('pds.delivery_cost.loading')}}</button>

        <div class="alert alert-info mt-3" v-if="response && !response.error">
            <p v-if="this.response.costs_unformatted <= 0" class="mb-0"><span>{{$t('pds.delivery_cost.result.zero_delivery_cost')}}</span></p>
            <div v-if="this.response.costs_unformatted != 0">
                <p class="mb-0"><span class="font-weight-bold">{{$t('pds.delivery_cost.result.cost')}}</span> {{ price }}</p>
                <p class="mb-0"><span class="font-weight-bold">{{$t('pds.delivery_cost.result.duration')}}</span> {{ duration }}</p>
                <p class="mb-0"><span class="font-weight-bold">{{$t('pds.delivery_cost.result.distance')}}</span> {{ distance }}</p>
            </div>
        </div>
    </div>
    <div v-else >
        <h3>{{$t('pds.delivery_cost.title')}}</h3>
        <div  class="form-group">
            <label>{{ $t('pds.delivery_cost.not_allowed.hint') }}</label>
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: 'DeliveryCalculatorBox',
    components: {
        VueGoogleAutocomplete
    },
    data() {
        return {
            address: '',
            error: '',
            response: null,
            isSubmitting: false,
        }
    },
    props: {
        entry: null,
        isLoading: true,
    },
    methods: {
        onBlur: function(addressData){

            if (this.googleAddress == undefined) {
                return
            }
            if (this.$refs.toAddress.$refs.autocomplete.value ==='') {
                this.address = ''
                return
            }

            if (this.$refs.toAddress.$refs.autocomplete.value !== this.googleAddress) {
                this.$refs.toAddress.$refs.autocomplete.value = this.googleAddress
            }

        },
        getAddressData: function (addressData, placeResultData, id) {
            this.googleAddress = this.$refs.toAddress.$refs.autocomplete.value;
            this.address = addressData;
        },
        getCosts: function (){
            this.isSubmitting = true
            if(this.address === ''){
                this.error = this.$t('pds.delivery_cost.address_error')
                this.isSubmitting = false
                return
            } else {
                this.$axios.post('api/v1/vehicle/delivery_cost', {
                    address: `${this.formattedAddress}`,
                    vehicle_uuid: this.entry.vehicle_uuid
                }).then((response) => {
                    if(response.error === true){
                        this.error = this.$t('pds.delivery_cost.error')
                    } else {
                        this.response = response.data
                    }
                    this.isSubmitting = false
                }).catch(e => {
                    this.error = this.$t('pds.delivery_cost.error')
                    this.isSubmitting = false
                })
            }
        },
        isAllowed: function(){
            if(this.$root.whitelabel.setting('show_cookie_consent')) {
                const cookieLocale = this.$getCookie("cookie_config")
                return cookieLocale.includes("Optional Functionalities")
            }
            return true
        }
    },
    computed: {
        price(){
            let text = ''

            if(this.response) {
                const price = this.$root.whitelabel.getFormatetPrice(this.response.costs_unformatted)
                const vatText = this.$root.whitelabel.setting('show_price_without_taxes') ? this.$root.whitelabel.getFormatetPrice(this.response.costs_unformatted) : ''

                text = `${price} ${vatText}`
            }

            return text
        },
        distance(){
          return this.response ? `${this.response.distance}` : ''
        },
        duration(){
            if(this.response){
                const duration = this.response.duration.replace(/[^0-9]/g,' ').replace(/\s+/g, ' ').split(' ')

                if(duration[1] !== ''){
                    const hourString = duration[0] > 1 ? this.$t('pds.delivery_cost.hours') : this.$t('pds.delivery_cost.hour')
                    const minuteString = duration[1] > 1 ? this.$t('pds.delivery_cost.minutes') : this.$t('pds.delivery_cost.minute')

                    return `${duration[0]} ${hourString} ${duration[1]} ${minuteString}`
                } else {
                    const minuteString = duration[0] > 1 ? this.$t('pds.delivery_cost.minutes') : this.$t('pds.delivery_cost.minute')

                    return `${duration[0]} ${minuteString}`
                }
            }
        },
        formattedAddress(){
          return `${this.route} ${this.number}, ${this.city} ${this.country}`
        },
        route(){
            return this.address.route ? this.address.route : ''
        },
        number(){
            return this.address.street_number ? this.address.street_number : ''
        },
        city(){
            return `${this.zip} ${this.locality},`
        },
        locality(){
            return this.address.locality ? this.address.locality : ''
        },
        zip(){
            return this.address.postal_code ? this.address.postal_code : ''
        },
        country(){
            return this.address.country ? `, ${this.address.country}`: ''
        }
    }
}
</script>
